import styled from 'styled-components';
import colors from '../../theme/colors';

const RateStarsBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RateStarsWrapper = styled.div`
  display: inline-flex;
  gap: 8px;
  color: ${colors.primary};
`;

const RateStarsLabel = styled.label`
  font-size: 14px;
  color: #595959;
`;

export { RateStarsWrapper, RateStarsBlockWrapper, RateStarsLabel };
